import { filterStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListFilter";
import { savedOrderListFilterStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListFilter";
import { savedOrderListTableStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable";

import { css } from "styled-components";

savedOrderListTableStyles.container = {
    css: css`
        overflow: auto;
        margin-top: 5px;
        background-color: #ffffff;
        border: 1px solid #efefef;
        box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
        border-radius: 7px;
    `,
};
savedOrderListFilterStyles.fromGridItem = {
    width: [12, 6, 6, 6, 6],
};
savedOrderListFilterStyles.toGridItem = {
    width: [12, 6, 6, 6, 6],
};
filterStyles.fromGridItem = {
    width: [12, 6, 6, 6, 6],
};
filterStyles.toGridItem = {
    width: [12, 6, 6, 6, 6],
};
filterStyles.datesGridItem = {
    width: [12, 12, 6, 6, 4],
};
